"use strict";

angular.module("app").directive("imgAssets", function () {
	return {
		restrict: 'EA',
		scope: {
			src: "=src",
		},
		link: function (scope, element) {

			let tag = document.createElement("img");
			tag.src = "assets/img/" + scope.src;
			element.append(tag);

		}
	};
});